import { styled } from '../../styled';
export var GalleryLayoutItem = styled('li', { name: 'QuantumGalleryLayout', slot: 'Item' })({});
